module.exports = __webpack_public_path__ + "assets/roboto-regular.f3cb490dedad47212dbe5f794082fe14ddcd027d97dde0df74cfe2ccfe2342fe.woff";